import { IOHAppService } from '../../services/ioh-app.service';
import {
  Train,
  TrainAwaitingDeparture,
  TrainLengthClassification,
  TrainLengthClassificationColor,
  TrainPerformanceClassificationColor,
  TrainPerformanceClassificationText
} from '../../models/train-info.model';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  effect
} from '@angular/core';

import { TrainDetails } from 'src/app/models/trainDetails';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { tableArrowDirectionClass } from 'src/app/constants/ioh-train-table-contant';
import { IOHDynamicDialogService } from '../service/ioh-dialog.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'csx-ioh-trains-table',
  templateUrl: './ioh-trains-table.component.html',
  styleUrls: ['./ioh-trains-table.component.scss'],
  imports: [CommonModule]
})
export class IOHTrainsTableComponent implements OnInit {
  @Input() close: boolean = false;
  @Input() trains: Train[] = [];
  @Input() terminalTrains: any[] = [];
  @Input() top: number = 0;
  @Input() left: number = 0;
  @Input() iohCollapseAll: boolean = false;
  @Input() showCount: number = 0;
  @Input() showClose: boolean = false;
  @Input() arrowDirection: number = 1;
  @Input() level: number = 0;
  @Input() terminalFlag: boolean = false;
  @Output() iohCloseChange = new EventEmitter<boolean>();
  @Output() iohMoreEvent = new EventEmitter<any | undefined>();
  @Input() iohTrainIdForSearch = '';
  _terminalTrains: TrainAwaitingDeparture[] = [];
  trainDetails: TrainDetails;
  slectedTrainInfo: Train;
  visible: boolean = false;
  public maskVisible: boolean = false;
  positionLeft = '90px';
  positionTop = '20px';
  marginStyle = {
    width: '350px',
    'background-color': '#232628',
    'box-shadow': '0px 2px 10px 0px #00000080',
    color: '#fff'
  };

  showDialog() {
    this.visible = true;
  }

  closeDialog() {
    this.visible = false;
  }

  intailTop = 0;
  iohZIndex = 1;

  iohShowCollapse: boolean = false;
  iohVisibleTrainCount = 0;
  iohTrainLengthByCount: number[][] = Array.from({ length: 5 }, (_, index) =>
    Array(index).fill(0)
  );
  tableArrowDirectionClass = tableArrowDirectionClass;
  trainLengthClassification = TrainLengthClassification;
  trainLengthClassificationColor = TrainLengthClassificationColor;
  trainPerformanceClassificationColor = TrainPerformanceClassificationColor;
  trainPerformanceClassificationText = TrainPerformanceClassificationText;
  trainLengthClassificationColors = [
    TrainLengthClassificationColor.REPORTED_LENGTH_CLASSIFICATION_2,
    TrainLengthClassificationColor.REPORTED_LENGTH_CLASSIFICATION_3,
    TrainLengthClassificationColor.REPORTED_LENGTH_CLASSIFICATION_4,
    TrainLengthClassificationColor.REPORTED_LENGTH_CLASSIFICATION_5
  ];
  iohDynamicFontSize = '';
  private destroy$ = new Subject<void>();

  constructor(
    private iohAppService: IOHAppService,
    private route: Router,
    private dynamicDialogService: IOHDynamicDialogService
  ) {
    effect(() => {
      this.iohDynamicFontSize = this.iohAppService.iohFontSizeValue$();
    });
  }

  ngOnInit() {
    this.iohCalculateVisibleCount();

    if (this.arrowDirection === 3 || this.arrowDirection === 6) {
      this.intailTop = this.top;
      if (this.trains.length <= this.showCount) {
        this.top += (this.showCount - this.trains.length + 1) * 22;
      }
    }

    if (this.showClose) {
      this.iohAppService.iohTableZIndexLevels[this.level] += 1;
    }
    this.iohZIndex = this.iohAppService.iohTableZIndexLevels[this.level];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.iohCollapseAll) {
      this.iohShowCollapse = false;
    }
    if (changes && changes.trains && this.intailTop) {
      this.top = this.intailTop;
      if (changes.trains.currentValue.length <= this.showCount) {
        this.top +=
          (this.showCount - changes.trains.currentValue.length + 1) * 22;
      }
    }
    this.iohCalculateVisibleCount();
  }

  //to expand train table on more label  click
  iohMoreClicked(tableData: any | undefined) {
    this.iohShowCollapse = true;
    this.iohVisibleTrainCount = this.trains.length;
    this.iohZIndex = ++this.iohAppService.iohTableZIndexLevels[this.level];
    this.iohMoreEvent.emit(1);
  }

  //to collapse train table on collapse label  click
  iohCollapseClicked() {
    this.iohShowCollapse = false;
    this.iohVisibleTrainCount = this.showCount;
    this.iohZIndex = 5;
    this.iohMoreEvent.emit(0);
  }

  //to close trains table
  iohCloseClicked() {
    this.iohMoreEvent.emit(0);
    this.iohCloseChange.emit(!this.close);
  }

  //to show more lable based on train counts
  iohCalculateVisibleCount() {
    if (
      this.trains &&
      (this.showCount === 0 ||
        this.showCount + 1 === this.trains.length ||
        this.iohShowCollapse)
    ) {
      this.iohVisibleTrainCount = this.trains.length;
      return;
    }
    this.iohVisibleTrainCount = this.showCount;
  }

  //to show train details web component
  iohShowTrainCallout(train) {
    this.dynamicDialogService.closeTrainCallout();
    this.dynamicDialogService.showTrainCallout(train);
  }

  //to append time zone
  iohAppendTimezoneIfMissing(dateString: string): string {
    return dateString.indexOf('Z') > -1 ? dateString : dateString + 'Z';
  }

  //to check for same date
  iohCheckSameDate(date1, date2) {
    date1 = this.iohAppendTimezoneIfMissing(date1);
    date2 = this.iohAppendTimezoneIfMissing(date2);
    return new Date(date1).getTime() - new Date(date2).getTime() === 0;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
